<template>
    <div
        id="app"
        class="o-app"
        :class="{
            'o-app--eko': ekoStatus === '1' && authStatus === 'loggedIn',
            'o-app--noPaddingTopBottom': removeTopBottomPadding
        }"
    >
        <o-notifications />
        <o-nav-top />
        <o-announcements />
        <o-banner v-if="$route.name === 'dashboard'" />
        <router-view :key="$route.fullPath" />
        <o-nav-bottom v-if="$route.meta.requiresAuth" />
        <o-first-login-modal />
        <div v-show="$route.name === 'settings'">
            <m-title title="Powiadomienia push" />
            <div class="l-row">
                <div class="l-row__column">
                    <div class="onesignal-customlink-container" v-show="$route.name === 'settings'"></div>
                </div>
            </div>
            <div class="l-row">
                <div class="l-row__column">
                    <a-button
                        type="fullwidth"
                        @click="onAccountRemove"
                        :is-processing="authStatus === 'pending'"
                    >
                        Usuń swoje konto
                    </a-button>
                </div>
            </div>
            <o-confirmation-modal
                @abort="$store.dispatch('modalHide', 'confirmation')"
                @approve="approveAccountRemove"
            >
                <div>
                    <a-icon icon="Alerts" />
                    <br />
                    <p class="a-text a-text--bold">
                        Czy na pewno chcesz usunąć swoje konto?
                    </p>
                    <p>
                        Usunięcie konta automatycznie anuluje subskrypcję i jest
                        nieodwracalne.
                    </p>
                </div>
            </o-confirmation-modal>
        </div>
    </div>
</template>

<script>
import ONotifications from '@/components/ONotifications'
import OFirstLoginModal from '@/components/global/OFirstLoginModal.vue'
import ONavBottom from '@/components/ONavBottom'
import ONavTop from '@/components/ONavTop'
import OBanner from '@/components/OBanner'
import OAnnouncements from '@/components/global/OAnnouncements.vue'
import OConfirmationModal from '@/components/global/OConfirmationModal'
export default {
    metaInfo: {
        title: 'Agrii Baza',
        titleTemplate:
            process.env.VUE_APP_MODE === 'production'
                ? '%s | Agrii Baza'
                : `%s | Agrii Baza [${process.env.VUE_APP_MODE.toUpperCase()}]`,
        meta: [
            {
                name: 'viewport',
                content: 'width=device-width,initial-scale=1.0'
            }
        ],
        htmlAttrs: {
            lang: 'pl'
        }
    },
    components: {
        ONotifications,
        ONavBottom,
        ONavTop,
        OBanner,
        OAnnouncements,
        OFirstLoginModal,
        OConfirmationModal
    },
    computed: {
        authStatus() {
            return this.$store.getters.authStatus
        },
        ekoStatus() {
            return this.$store.getters['eko/status']
        },
        removeTopBottomPadding() {
            return this.$route.name === 'login' || this.$route.name === 'register' || this.$route.name === undefined
        }
    },
    methods: {
        async approveAccountRemove() {
            this.$store.dispatch('modalHide', 'confirmation')
            try {
                await this.$store.dispatch('removeAccount')
                this.$router.push({ name: 'logout' })
            } catch (error) {
                this.$store.dispatch('addNotification', {
                    type: 'danger',
                    content: `Wystąpił błąd. ${error.message}`
                })
            }
        },
        onAccountRemove() {
            this.$store.dispatch('modalShow', 'confirmation')
        }
    },
    created() {
        this.$store.dispatch('fetchDeviceInfo')
    }
}
</script>
<style lang="sass">
.onesignal-customlink-container .button
    background-color: var(--color-primary)!important
</style>
